import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/app/environments/environments';
import { Capacitor } from '@capacitor/core';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private readonly API_BASE_URL = environment.apiUrl;

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isInternalApi = req.url.startsWith(this.API_BASE_URL);

    if (isInternalApi) {
      const userDetail = localStorage.getItem('UserDetails');
      if (userDetail && userDetail.trim()) {
        const platform = this.getPlatform();

        const clonedRequest = req.clone({
          setHeaders: {
            LoginId: userDetail,
            Environment: environment.type,
            Domain: window.location.hostname,
            'Device-Identifier': this.getDeviceFingerprint(),
            'Device-Name': `${platform} - ${this.getBrowserName()}`,
            Platform: platform.toLowerCase(), // Added Platform header for your API
          },
        });
        return next.handle(clonedRequest);
      }
    }

    return next.handle(req);
  }

  private getPlatform(): string {
    try {
      return Capacitor.getPlatform();
    } catch (error) {
      return 'web';
    }
  }

  private getBrowserName(): string {
    const userAgent = navigator.userAgent;

    if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
      return 'Chrome';
    } else if (userAgent.includes('Firefox')) {
      return 'Firefox';
    } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      return 'Safari';
    } else if (userAgent.includes('Edg')) {
      return 'Edge';
    } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
      return 'Opera';
    } else {
      return 'Unknown';
    }
  }

  private getDeviceFingerprint(): string {
    try {
      const fingerprint = [
        navigator.userAgent,
        navigator.language,
        screen.width + 'x' + screen.height,
        new Date().getTimezoneOffset(),
        this.getPlatform(),
      ].join('|');

      // Simple hash
      return this.simpleHash(fingerprint).substring(0, 32);
    } catch (error) {
      // Fallback
      return this.simpleHash(navigator.userAgent + Date.now()).substring(0, 32);
    }
  }

  private simpleHash(str: string): string {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    return Math.abs(hash).toString(16);
  }
}
